import { Injectable } from "@angular/core";
import Handsontable from "handsontable";
import { RenderControllerService } from "./render-controller.service";

// Selection recovery is scoped to the update-information form.
@Injectable({ providedIn: "root" })
export class NegotiationRenderControllerService extends RenderControllerService {
  public renderCheckboxController(field: any): any {
    return (hotInstance, td, row, prop, col, value, cellProperties) => {
      // Render dom repend on state
      // let listController = '';
      const divWrap: Node = this.createDomByStringHtml(`<div></div>`);
      if (cellProperties.valid === false) {
        td.className += ' htInvalid';
      }
      let valueId = [];
      try {
        const parsed = typeof value === 'string' ? JSON.parse(value) : value;
        valueId = Array.isArray(parsed)
          ? parsed.filter(id => typeof id === 'string' || typeof id === 'number') : [];
      } catch (_) {
        // Invalid persisted/pasted data must not interrupt rendering the table.
      }
      for (const sourceField of (Array.isArray(field.data) ? field.data : [])) {
        if (!sourceField || sourceField.id == null) {
          continue;
        }
        let isChecked = '';
        const disabled = !field.editable ? 'disabled' : '';
        if (valueId.some(id => String(id) === String(sourceField.id))) {
          isChecked = 'checked';
        }
        const checkbox: Node = this.createDomByStringHtml(
          `<input class="form-check-input checkbox-${field.code}" name="${sourceField.value}" type="checkbox" value="${sourceField.id}" ${isChecked} ${disabled}>`
        );
        const label: Node = this.createDomByStringHtml(
          `<label class="form-check-label" for="${sourceField.code}" style="margin-left: 5px;">${sourceField.value}</label>`
        );
        const listController: Node = this.createDomByStringHtml(
          `<div class="form-check"></div>`
        );
        checkbox.addEventListener('change', (event: any) => {
          this.checkboxClickHandler(event, row, col, hotInstance, valueId);
        });
        listController.appendChild(checkbox);
        listController.appendChild(label);
        divWrap.appendChild(listController);
      }
      td.style.whiteSpace = 'normal';
      Handsontable.dom.empty(td);
      td.appendChild(divWrap);
    };
  }

  public checkboxClickHandler(
    event: any,
    col: number,
    row: number,
    hotInstance: any,
    valueId: any
  ): void {
    let cellValueIdHolder = Array.isArray(valueId) ? valueId : [];
    if (event.target.checked) {
      if (!cellValueIdHolder.some(id => String(id) === event.target.value)) {
        cellValueIdHolder.push(event.target.value);
      }
    } else {
      cellValueIdHolder = cellValueIdHolder.filter(valueId => {
        return String(valueId) !== event.target.value;
      });
    }
    const valueIdString =
      cellValueIdHolder.length > 0 ? JSON.stringify(cellValueIdHolder) : null;
    hotInstance.setDataAtRowProp(col, row, valueIdString);
  }

  public renderRadioController(field: any): any {
    return (hotInstance, td, row, prop, col, value, cellProperties) => {
      // Render dom repend on state
      // let listController = '';
      const divWrap: Node = this.createDomByStringHtml(`<div></div>`);
      if (cellProperties.valid === false) {
        td.className += ' htInvalid';
      }
      for (const sourceField of (Array.isArray(field.data) ? field.data : [])) {
        if (!sourceField || sourceField.id == null) {
          continue;
        }
        let isChecked = '';
        const disabled = !field.editable ? 'disabled' : '';
        if (value != null && String(value) === String(sourceField.id)) {
          isChecked = 'checked';
        }
        const radio: Node = this.createDomByStringHtml(
          `<input class="form-check-input radio-${field.code}" id="${field.code}_${sourceField.id}" name="${field.code}" type="radio" value="${sourceField.id}" ${isChecked} ${disabled}>`
        );
        const label: Node = this.createDomByStringHtml(
          `<label class="form-check-label" for="${field.code}_${sourceField.id}" style="margin-left: 5px;">${sourceField.value}</label>`
        );
        const listController: Node = this.createDomByStringHtml(
          `<div class="form-check"></div>`
        );
        radio.addEventListener('change', (event: any) => {
          hotInstance.setDataAtCell(row, 2, event.target.value);
        });
        listController.appendChild(radio);
        listController.appendChild(label);
        divWrap.appendChild(listController);
      }
      td.style.whiteSpace = 'normal';
      Handsontable.dom.empty(td);
      td.appendChild(divWrap);
    };
  }

}
